import { ca } from '@cian/analytics';

import { TJsonQuery } from 'packages/JsonQuery';

interface ITrackingParams {
  offerId: number;
  jsonQuery: TJsonQuery;
  source?: string;
}

/**
 * Событие #1
 *
 * Клик по сумме ипотечного платежа
 *
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1472752283
 */
export const trackMortgagePaymentClick = ({ offerId, jsonQuery }: ITrackingParams) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'monthly_payment',
    sc: jsonQuery,
    products: [
      {
        id: offerId,
      },
    ],
  });
};

/**
 * Событие #2
 *
 * Показ информации по платежу
 *
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1472752283
 */
export const trackMortgagePaymentInfoShow = ({ offerId, jsonQuery }: ITrackingParams) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'show_sopr',
    category: 'Listing',
    label: 'about_payment_tooltip',
    sc: jsonQuery,
    products: [
      {
        id: offerId,
      },
    ],
  });
};

/**
 * Событие #3
 *
 * Клик по ссылке внутри тултипа
 *
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1472752283
 */
export const trackMortgagePaymentInfoLinkClick = ({ offerId, jsonQuery, source }: ITrackingParams) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_sopr',
    category: 'Listing',
    label: 'about_payment_details',
    sc: jsonQuery,
    products: [
      {
        id: offerId,
      },
    ],
    page: {
      extra: {
        type: 'details',
        source,
      },
    },
  });
};
